import {useDictionary, useItems} from '@adamlip/okeoke.client'
import {Chip} from '@heroui/react'
import OrderItemCard from 'views/_Order/Order/Items/ItemCard'

export default function GroupMember({member, group, sizeGroupUUID, addMember, selectedCount}) {
	const {sizes, assembledItems} = useItems()
	const {getValue} = useDictionary()
	const onAdd = (item) => {
		addMember({...item, sizeGroupUUID, price: member.price, memberUUID: member.uuid})
	}
	let filteredGroupMembersCount = group?.members?.filter((m) => {
		if (assembledItems?.[sizes?.[m.uuid]?.itemUUID]?.visibleSizes > 0) {
			return true
		} else {
			return false
		}
	})

	if (assembledItems?.[sizes?.[member.uuid]?.itemUUID]?.visibleSizes < 1) {
		return null
	}
	return (
		<div className='relative w-full '>
			{selectedCount != null && selectedCount > 0 && (
				<Chip size='sm' color='primary' className='flex justify-center items-center rounded-full absolute top-[0px] right-0 z-10 text-sm'>
					{selectedCount} {getValue('app_v2_menu_selected')}
				</Chip>
			)}
			{/* TODO GERGŐ */}
			<OrderItemCard
				itemUUID={sizes?.[member.uuid]?.itemUUID}
				isLoading={sizes?.[member.uuid]?.itemUUID == null}
				menuItemParams={{
					onAdd,
					defaultCount: member.defaultCount === 0 ? (group?.minSelect > 0 && filteredGroupMembersCount?.length === 1 ? 1 : 0) : member.defaultCount,
					minSelect: member.minSelect,
					maxSelect: member.maxSelect,
					selectedSizeUUID: member.uuid,
					price: member.price,
					selected: selectedCount > 0,
					onScreenOff: true,
					shouldAutoAdd: group?.minSelect > 0 && group?.members?.length === 1,
				}}
			/>
		</div>
	)
}
